"use client";

import { useEffect, useRef, useState } from "react";

function FadeIn({ children }: { children: React.ReactNode }) {
  const [isVisible, setIsVisible] = useState(false);
  const domRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => setIsVisible(entry.isIntersecting));
      },
      { threshold: 0.1 },
    );
    const current = domRef.current;
    if (current) observer.observe(current);
    return () => {
      if (current) observer.unobserve(current);
    };
  }, []);

  return (
    <div
      ref={domRef}
      className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
    >
      {children}
    </div>
  );
}

export default function IntroSection() {
  return (
    <>
      <div className="bg-white h-5"></div>
      <section className="py-10 gap-6 bg-green-50 overflow-hidden">
        <div className="container mx-auto px-4 sm:px-6 md:px-8">
          <div className="flex flex-col gap-8 md:gap-10 items-start">
            <FadeIn>
              <div className="space-y-4">
                <p className="text-gray-700 text-base  leading-relaxed font-medium text-justify">
                  KarnatakaAgribusiness.com is an agriculture-focused digital trading and business platform connecting buyers, farmers, FPOs, agricultural suppliers, vendors, traders, manufacturers, and service providers. The platform brings together three major areas of the agricultural ecosystem such as Agri-Inputs, Agri-Output, and Agri-Services to create wider opportunities for sourcing, selling, networking and business development. Unlike a conventional e-commerce website, KarnatakaAgribusiness.com is designed as a sector-focused business platform where both buyers and sellers can participate. Buyers can discover agricultural inputs, agricultural output or produce and specialized services, while vendors, producers and service providers can showcase their products, capabilities, credentials and offerings. Sellers and service providers may operate from Karnataka, other parts of India and outside the country, while the primary market focus remains Karnataka and adjoining regions.
                  Through FPO Connect, Vendor Profiles, product listings and service listings, the platform aims to strengthen agricultural business linkages and create a connected ecosystem extending beyond product transactions. By bringing products, agricultural produce, services and business participants together, KarnatakaAgribusiness.com seeks to create practical opportunities across the agricultural value chain.
                </p>
              </div>
            </FadeIn>

            <FadeIn>
              <div>
                <p className="text-gray-700 text-base leading-relaxed font-medium text-justify">
                  www.KarnatakaAgribusiness.com ಕರ್ನಾಟಕದಾದ್ಯಂತ ರೈತರು, FPOಗಳು,
                  ಮಾರಾಟಗಾರರು ಮತ್ತು ಕೃಷಿ ಸೇವಾ ಪೂರೈಕೆದಾರರನ್ನು ಸಂಪರ್ಕಿಸುವ ಡಿಜಿಟಲ್
                  ಮಾರುಕಟ್ಟೆಯಾಗಿದೆ. ರೈತರು ಉತ್ಪನ್ನಗಳನ್ನು ಮಾರಾಟ ಮಾಡಬಹುದು, ಮಾರಾಟಗಾರರು
                  ಇನ್‌ಪುಟ್‌ಗಳನ್ನು ಪೂರೈಸಬಹುದು ಮತ್ತು ಸೇವಾ ಪೂರೈಕೆದಾರರು ಪರಿಣತ ಸಲಹೆ
                  ನೀಡಬಹುದು. ಕೃಷಿ ಇನ್‌ಪುಟ್‌ಗಳು, ಕೃಷಿ ಉತ್ಪನ್ನಗಳು ಮತ್ತು ಕೃಷಿ
                  ಸೇವೆಗಳಂತಹ ವಿಭಾಗಗಳೊಂದಿಗೆ, ಈ ವೇದಿಕೆಯು ಪಾರದರ್ಶಕ ವ್ಯಾಪಾರ ಮತ್ತು ವಿಶಾಲ
                  ಮಾರುಕಟ್ಟೆ ಪ್ರವೇಶವನ್ನು ದೊರೆಕಿಸುತ್ತದೆ. FPO connect ನಿಂದ
                  ಬೆಂಬಲಿತವಾಗಿದೆ, ಇದು ಕೊಳ್ಳುವಿಕೆ ಅನ್ನು ಬಲಪಡಿಸುತ್ತದೆ ಮತ್ತು
                  ವಿಶ್ವಾಸಾರ್ಹ ಮಾರುಕಟ್ಟೆಗಳನ್ನು ಸೃಷ್ಟಿಸುತ್ತದೆ. ಈ ವೆಬ್‌ಸೈಟ್ ಎಲ್ಲಾ
                  ಪಾಲುದಾರರು ಪ್ರಯೋಜನ ಪಡೆಯುವ ಸುಸ್ಥಿರ, ರಾಜ್ಯವ್ಯಾಪಿ ಕೃಷಿ ವ್ಯವಹಾರ ಪರಿಸರ
                  ವ್ಯವಸ್ಥೆಯನ್ನು ದೊರೆಕಿಸಿಕೊಡುತ್ತದೆ.
                </p>
              </div>
            </FadeIn>
          </div>
        </div>
      </section>
    </>
  );
}
